import apiClient from '@shared/api/client';

/**
 * 取得明信片圖案列表
 * GET /v1/interact/postcard/item/list
 * @returns {Promise<{ items: Array<{ category: string, items: Array<{ item_id, name, desktop_url, mobile_url }> }> }>}
 */
export async function getPostcardItems() {
  const res = await apiClient.get('/v1/interact/postcard/item/list');
  return res.items ?? [];
}

/**
 * 創建明信片
 * POST /v1/interact/postcard/record/add
 * @param {{ item_id: number, content: string, from_name: string, to_name: string }} payload
 * @returns {Promise<{ record_id: number, share_code: string }>}
 */
export async function createPostcard(payload) {
  const res = await apiClient.post('/v1/interact/postcard/record/add', payload);
  return res;
}

/**
 * 取得明信片詳情
 * POST /v1/interact/postcard/record/describe
 * @param {{ share_code?: string, record_id?: number }} payload 二擇一必填
 * @returns {Promise<object>}
 */
export async function getPostcard(payload) {
  const res = await apiClient.post('/v1/interact/postcard/record/describe', payload);
  return res;
}
